import React, { useState } from 'react';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { setDoc, doc } from 'firebase/firestore';
import { auth, db } from '../firebase/config';

// import {
//   auth,
//   signInWithEmailAndPassword,
//   sendPasswordResetEmail,
//   createUserWithEmailAndPassword,
//   setDoc,
//   doc,
//   db,
//   addDoc,
//   collection,
//   signOut,
//   onAuthStateChanged,
//   query,
//   where,
//   onSnapshot,
// } from '/Users/adityarouniyar/Desktop/convoai/src/firebase/config.js';

import Logo from '../components/common/Logo';

const SignupPage = ({ setModalType, closeModal }) => {
    const [formData, setFormData] = useState({
        firstName: '',
        middleName: '',
        lastName: '',
        companyName: '',
        email: '',
        password: '',
        confirmPassword: '',
        agreedToTerms: false,
    });
    const [error, setError] = useState('');
    const [passwordError, setPasswordError] = useState('');

    const validatePassword = (password) => {
        const errors = [];
        if (password.length < 8) errors.push("at least 8 characters");
        if (!/[A-Z]/.test(password)) errors.push("one uppercase letter");
        if (!/[a-z]/.test(password)) errors.push("one lowercase letter");
        if (!/\d/.test(password)) errors.push("one number");
        if (!/[^A-Za-z0-9]/.test(password)) errors.push("one special character");
        return errors.join(', ');
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));

        if (name === 'password') {
            const validationError = validatePassword(value);
            setPasswordError(validationError);
        }
    };

    const handleSignup = async (e) => {
        e.preventDefault();
        setError('');
        if (passwordError) {
            setError("Please fix the errors in your password.");
            return;
        }
        if (formData.password !== formData.confirmPassword) {
            setError("Passwords do not match.");
            return;
        }
        if (!formData.agreedToTerms) {
            setError("You must agree to the Terms of Service and Privacy Policy.");
            return;
        }

        try {
            const userCredential = await createUserWithEmailAndPassword(auth, formData.email, formData.password);
            const user = userCredential.user;

            await setDoc(doc(db, "users", user.uid), {
                firstName: formData.firstName,
                lastName: formData.lastName,
                companyName: formData.companyName,
                email: formData.email,
                role: 'user',
                createdAt: new Date().toISOString()
            });

            closeModal();
        } catch (err) {
            console.error("Signup error:", err);
            setError(err.message || "An error occurred during signup. Please try again.");
        }
    };

    return (
        <div className="p-10">
            <div>
                <div className="mx-auto h-12 w-auto flex justify-center">
                    <Logo />
                </div>
                <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
                    Create your account
                </h2>
            </div>
            <form className="mt-8 space-y-6" onSubmit={handleSignup}>
                {error && <p className="text-red-500 text-sm text-center bg-red-100 p-3 rounded-md">{error}</p>}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <input name="firstName" type="text" value={formData.firstName} onChange={handleChange} required className="input-style" placeholder="First Name" />
                    <input name="lastName" type="text" value={formData.lastName} onChange={handleChange} required className="input-style" placeholder="Last Name" />
                    <input name="middleName" type="text" value={formData.middleName} onChange={handleChange} className="input-style" placeholder="Middle Name (Optional)" />
                    <input name="companyName" type="text" value={formData.companyName} onChange={handleChange} className="input-style" placeholder="Company Name (Optional)" />
                </div>
                <input name="email" type="email" value={formData.email} onChange={handleChange} required className="input-style w-full" placeholder="Email Address" />
                <div>
                    <input name="password" type="password" value={formData.password} onChange={handleChange} required className="input-style w-full" placeholder="Password" />
                    {passwordError && <p className="text-red-500 text-xs mt-1">Password must contain: {passwordError}</p>}
                </div>
                <input name="confirmPassword" type="password" value={formData.confirmPassword} onChange={handleChange} required className="input-style w-full" placeholder="Confirm Password" />

                <div className="flex items-start">
                    <div className="flex items-center h-5">
                        <input id="agreedToTerms" name="agreedToTerms" type="checkbox" checked={formData.agreedToTerms} onChange={handleChange} className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded" />
                    </div>
                    <div className="ml-3 text-sm">
                        <label htmlFor="agreedToTerms" className="font-medium text-gray-700">I agree to the <a href="#" className="text-indigo-600 hover:underline">Terms of Service</a> and <a href="#" className="text-indigo-600 hover:underline">Privacy Policy</a></label>
                    </div>
                </div>

                <div>
                    <button type="submit" className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-[#B67BF4] hover:bg-[#7B34BB] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                        Create Account
                    </button>
                </div>
            </form>
             <p className="mt-4 text-center text-sm text-gray-600">
                Already have an account?{' '}
                                        <a href="#" onClick={() => setModalType('login')} className="font-medium text-indigo-600 hover:text-[#7B34BB]">
                    Sign in
                </a>
            </p>
        </div>
    );
};

export default SignupPage;

